import { create } from 'zustand';
import { StateCreator } from 'zustand';
import { devtools } from 'zustand/middleware';

export type WithDevtools<T> = T & {
  /** Devtools properties added by the middleware */
  devtools?: {
    prefix: string;
  };
};

/**
 * Creates a Zustand store with devtools middleware enabled
 * @param storeFn - State creator function for the store
 * @param name - Display name for the store in devtools
 * @returns Configured Zustand store with devtools
 */
const createStoreWithDevtools = <T extends object>(storeFn: StateCreator<T, [['zustand/devtools', never]], [], T>, name: string) => {
  return create<T, [['zustand/devtools', never]]>(devtools(storeFn, { name }));
};

export default createStoreWithDevtools;
